module.exports = __webpack_public_path__ + "static/media/avatar-placeholder-female.ca558af5.jpg";